(function( $ ) {
  'use strict';

  $(window).load(function() {
    $(".hero-row, .highlight_box_v2-row").each(function() {
      const lazyVideo = $(this).is(".hero-row")
        ? $(this).find(".video-container video.lazy")
        : $(this).find(".background.video video.lazy");

      if (lazyVideo && lazyVideo.length > 0) {
        const config = {
          root: document.body,
          rootMargin: "0px",
          threshold: 0.000001
        };

        const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(video => {
            if (video.isIntersecting) {
              const source = $(video.target).find("source");
              $(source).attr("src", $(source).data("src"));
              $(source).removeAttr("data-src");

              video.target.load();
              $(video.target).removeClass("lazy");

              lazyVideoObserver.unobserve(video.target);
            }
          })
        }, config);

        lazyVideoObserver.observe(lazyVideo[0]);
      }
    });
  })
})( jQuery );
